import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";
import { getAllCpDbs } from "@services/api";
import * as React from "react";
import { View, ActivityIndicator } from "react-native";
import { colors } from "@constants/theme";
import t from "@constants/localization";
import AddDeliveryBoy from "./AddDeliveryBoy";
import DbList from "./DbList";

const CreateDbOrList = ({ navigation, route }) => {
  const [cpDeliveryBoys, setCpDeliveryBoys] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const { data } = await getAllCpDbs();
      setCpDeliveryBoys(data?.dbs || []);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const PATH = "screens/CpDeliveryBoys/createDbOrList";

  if (loading) {
    return (
      <>
        <HeaderWithBackAndTitle
          headertitle={t(`${PATH}/headerTitle`)}
          headerColor="#fff"
          hideShadow={false}
          navigation={navigation}
          route={route}
        />
        <View
          style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
        >
          <ActivityIndicator size="large" color={colors.primary} />
        </View>
      </>
    );
  }

  return (
    <>
      <HeaderWithBackAndTitle
        headertitle={t(`${PATH}/headerTitle`)}
        headerColor="#fff"
        hideShadow={false}
        navigation={navigation}
        route={route}
      />
      {cpDeliveryBoys &&
      Array.isArray(cpDeliveryBoys) &&
      cpDeliveryBoys.length > 0 ? (
        <DbList fetchData={fetchData} cpDeliveryBoys={cpDeliveryBoys} />
      ) : (
        <View style={{ margin: 10 }}>
          <AddDeliveryBoy fetchData={fetchData} isModal={false} />
        </View>
      )}
    </>
  );
};

export default CreateDbOrList;
